import React, {useEffect} from 'react';
import {AdvancedMarker, APIProvider, Map, InfoWindow, Pin, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import ReactDOM from 'react-dom/client'
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
const libraries = ['places'];
const mapContainerStyle = {
    height: '400px',
    width: '70%'
};

const options = {
    disableDefaultUI: true,
    zoomControl: true,
};

function MiniMapOpenLocation({ coordinates,doctor }) {
    const center = [34.052235,118.243683];
  const [showingInfoWindow, setShowingInfoWindow] = React.useState(true);
    const [activeMarker, setActiveMarker] = React.useState({});



    return (
        <div style={{position: "relative"}}>

            {coordinates ? (
                <div style={{position: "relative", height: "200px"}}>
                    <MapContainer
                        center={coordinates}
                        zoom={13}
                        style={{height: "100%", width: "100%"}}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; OpenStreetMap contributors"
                        />
                        {coordinates && (
                            <Marker
                                position={coordinates}
                                draggable={false}

                            >
                                <Popup  open={true} >
                                    <div>
                                        <h4>{doctor.info.name}</h4>
                                        <h4>{doctor.info.hospital}</h4>
                                        <p>{doctor.info.address}</p>
                                        <p>{doctor.info.city}</p>
                                        <p>{doctor.info.district}</p>
                                    </div>
                                </Popup>
                            </Marker>
                        )}
                    </MapContainer>
                </div>
            ) : (
                <p>Konumunuz alınıyor...</p>
            )}
        </div>
            )

            }

            export default MiniMapOpenLocation;